import { useEffect, useState } from "react";
import BookCard from "./BookCard";
import SectionHdr from "./SectionHeader";
import { fetchCategories } from "../api";

export default function CategorySection({ books = [], selectedBooks = [], itemLimit = 5, onView, cart, addCart }) {
    const getIcon = (cat) => {
        if (!cat) return "Book";
        const c = cat.toLowerCase();
        if (c.includes("gst")) return "GST";
        if (c.includes("tax")) return "Tax";
        if (c.includes("company") || c.includes("corporate")) return "Co";
        if (c.includes("insolvency") || c.includes("bankruptcy")) return "IBC";
        if (c.includes("customs") || c.includes("export") || c.includes("import")) return "EXIM";
        if (c.includes("fema") || c.includes("foreign")) return "FX";
        if (c.includes("sebi") || c.includes("securit")) return "SEBI";
        if (c.includes("audit") || c.includes("account")) return "Audit";
        if (c.includes("banking") || c.includes("finance")) return "Bank";
        return "Book";
    };

    const sourceBooks = selectedBooks.length ? selectedBooks : books;

    const [categories, setCategories] = useState([]);
    const [activeCatState, setActiveCat] = useState(null);

    useEffect(() => {
        const loadCategories = async () => {
            try {
                const data = await fetchCategories();
                // Filter out the 'all' placeholder and add icons
                const formatted = data
                    .filter(c => c.id !== 'all')
                    .map(c => ({
                        ...c,
                        id: c.label, // Use label as ID to match book.cat
                        icon: getIcon(c.label)
                    }));
                setCategories(formatted);
                if (formatted.length > 0 && !activeCatState) {
                    setActiveCat(formatted[0].id);
                }
            } catch (err) {
                console.error("Failed to load categories", err);
            }
        };
        loadCategories();
    }, []);

    const activeCat = activeCatState || (categories.length > 0 ? categories[0].id : null);

    const categoryBooks = sourceBooks
        .filter((book) => (book.cat || "Uncategorized") === activeCat)
        .slice(0, itemLimit);

    if (sourceBooks.length === 0 || categories.length === 0) return null;

    return (
        <section className="section" style={{
            background: "#FDF5F5",
            paddingTop: "10px",
            paddingBottom: "10px",
            borderTop: "3px solid #C0392B",
        }}>
            <SectionHdr pill="EXPLORE BY CATEGORY" />

            <div style={{ display: "flex", gap: 10, marginBottom: 18, flexWrap: "wrap" }}>
                {categories.map((category) => (
                    <button
                        key={category.id}
                        onClick={() => setActiveCat(category.id)}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 8,
                            padding: "10px 20px",
                            borderRadius: 50,
                            border: `2px solid ${activeCat === category.id ? "#C0392B" : "#f0d0d0"}`,
                            background: activeCat === category.id
                                ? "linear-gradient(135deg, #C0392B, #96221A)"
                                : "white",
                            color: activeCat === category.id ? "white" : "#8B1A1A",
                            fontSize: 13,
                            fontWeight: 700,
                            cursor: "pointer",
                            transition: "all 0.2s",
                            fontFamily: "'Nunito Sans',sans-serif",
                            boxShadow: activeCat === category.id ? "0 4px 14px rgba(192,57,43,0.3)" : "none",
                        }}
                    >
                        <span>{category.icon}</span>
                        {category.label}
                        <span style={{ fontSize: 10, opacity: 0.7 }}>({category.count})</span>
                    </button>
                ))}
            </div>

            <div style={{ display: "flex", gap: 22, overflowX: "auto", paddingBottom: 12 }}>
                {categoryBooks.map((book, index) => (
                    <div key={book._id} style={{ animation: `fadeUp 0.4s ${index * 0.07}s both`, flexShrink: 0 }}>
                        <BookCard book={book} onView={onView} cart={cart} addCart={addCart} />
                    </div>
                ))}
            </div>
        </section>
    );
}
